import { render, staticRenderFns } from "./plan-index.vue?vue&type=template&id=b8a6ec36"
import script from "./plan-index.vue?vue&type=script&lang=js"
export * from "./plan-index.vue?vue&type=script&lang=js"
import style0 from "./plan-index.vue?vue&type=style&index=0&id=b8a6ec36&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports